import { render } from "./z-appmain.vue?vue&type=template&id=d37edc62"
import script from "./z-appmain.vue?vue&type=script&lang=js"
export * from "./z-appmain.vue?vue&type=script&lang=js"

import exportComponent from "D:\\AAA-project-LK\\loginform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__